import { Injectable } from "@angular/core";
import { IID_OL_DEACTIVATION } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolDeactivationStore } from "./iidOlDeactivation.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_DEACTIVATION)
export class IIDolDeactivationQuery extends AbstractInterfaceDataQuery<IID_OL_DEACTIVATION> {

  constructor(protected store: IIDolDeactivationStore) {
    super(store);
  }
}
